export default "__VITE_ASSET__ad653c5a__"